const cardStatusList = [
  {
    Code: 'Draft',
    Name: 'Belum Final',
    Icon: 'fa-solid fa-exclamation',
    PrimaryColor: '#FB8C00',
    SecondaryColor: '#FFF3E0'
  },
  {
    Code: 'Finalized',
    Name: 'Final',
    Icon: 'fa-solid fa-check',
    PrimaryColor: '#04776D',
    SecondaryColor: '#DDF6F3'
  },
  // {
  //   Code: 'Cancelled',
  //   Name: 'Dibatalkan',
  //   Icon: 'fa-solid fa-xmark',
  //   PrimaryColor: '#F40023',
  //   SecondaryColor: '#FFEBEB'
  // }
]

export default cardStatusList